import { createFileRoute, redirect } from "@tanstack/react-router";
import PortalScopeEmptyState from "src/components/app/PortalScopeEmptyState/PortalScopeEmptyState";
import { projectPath } from "src/lib/PortalPaths";

// An organisation opens on the visitor's last project in it, or offers to create its first.
export const Route = createFileRoute("/_authed/portal/org_{$orgKey}/")({
  loader: async ({ parentMatchPromise }) => {
    const scope = (await parentMatchPromise).loaderData;
    if (scope?.project) throw redirect({ href: projectPath(scope.project.id), replace: true });
  },
  component: () => <PortalScopeEmptyState missing="project" />,
});
